import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _, { parseInt } from "lodash";
import {
  clickStreamUser,
  convertHoursToMins,
  convertSecondsToMins,
  convertTimeFormat,
  convertTimeInHourAndMin,
  fixedToDecimal,
  formatSecondsHand,
  getProcureInfo,
  ProductCardPriceInfo,
  redirectToPageUtil,
  SessionKeys,
} from "../../utils/AppUtils";
import { useNavigate } from "react-router-dom";
import WishListCourseCard from "./WishListCourseCard";
import CartSummaryCard from "../Cart/CartSummaryCard";
import { myCart } from "../../redux/Cart/actions";
import { getCreditPoint } from "../../redux/creditPoints/actions";
import { cartPageDataResponse } from "../../redux/checkout/actions";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";
import ProductCardComponent from "../NewDesign/ProductCard/ProductCardComponent";
import { getShowLoader } from "../../redux/home/actions";
import { useTranslation } from "react-i18next";
const WishlistSection = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const myCartRes = useSelector((state) => state.carts.myCart);
  const saveForLaterRes = useSelector((state) => state.carts.myCartSaveLater);
  const myCartSaveLaterViewRes = useSelector(
    (state) => state?.carts?.myCartSaveLaterView?.payload
  );
  const creditPoints = useSelector((state) => state.creditPoints.creditPoints);
  const wishListRes = useSelector((state) => state.product.getWishList);
  const auth = useSelector((state) => state.auth.auth);
  const authBroker = useSelector((state) => state.auth.authBroker);

  const [wishlist, setWishList] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState(
    "Added in cart successfully"
  );
  const [courseId, setCourseId] = useState(false);

  const [userCreditPoint, setUserCreditPoint] = useState(0);
  const [redeemCard, setRedeemCard] = useState(false);
  const [myCartDetails, setMyCartDetails] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [subTotalPrice, setSubTotalPrice] = useState(0);
  const [savedData, setSavedData] = useState([]);

  const [couponDetail, setCouponDetail] = useState({});
  const [isAppliedCoupon, setIsAppliedCoupon] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      dispatch(
        myCart({
          module: "myCart",
          email: authBroker?.payload?.user?.email,
          // userId: localStorage.getItem(SessionKeys.EMAIL_SESSION)
        })
      );
      dispatch(
        getCreditPoint({
          module: "getCreditPoint",
          email: authBroker?.payload?.user?.email,
        })
      );
    }
  }, [dispatch, authBroker]);

  useEffect(() => {
    // console.log("subTotalPrice: ", "redeem");
    if (redeemCard) {
      // console.log(_.toNumber((userCreditPoint / 10).toFixed(2)), subTotalPrice);
      setTotalPrice(subTotalPrice - userCreditPoint / 10);
    } else {
      setTotalPrice(subTotalPrice);
    }
  }, [redeemCard]);

  useEffect(() => {
    // console.log("subTotalPrice: ", "redeemUse");
    totalPriceFromApi();
    //    if(couponCode===''){
    //     setIsAppliedCoupon(false)
    //     setCouponCode('')
    //    }
  }, [couponDetail]);

  const totalPriceFromApi = () => {
    // console.log("subTotalPrice: ", "fromApi");
    if (Object.keys(couponDetail).length > 0) {
      // console.log("couponDetailCall ", couponDetail);
      setTotalPrice(_.toNumber(couponDetail?.orderTotal));
    }
    // else {
    //     if (Object.keys(couponDetail).length === 0) {
    //         console.log('couponDetailCall1 ',subTotalPrice)
    //         setTotalPrice(subTotalPrice)
    //     }
    // }
  };

  useEffect(() => {
    // console.log("myCartRes: ", myCartRes);
    // console.log("length", myCartRes);
    if (_.isEmpty(myCartRes) || _.isEmpty(myCartRes.cart_list)) {
      setMyCartDetails([]);
    } else {
      let cartData = _.cloneDeep(myCartRes?.cart_list);
      for (let cart of cartData) {
        // console.log("myCartRes", cart);
        cart.is_bundle = false;
        if (cart.sfdc_product_type.toLowerCase() === "bundle") {
          cart.is_bundle = true;
          for (let course of cart.course_list) {
            cart.course_lessons = cart.course_lessons + course.lessons;
            cart.course_duration = cart.course_duration + course.duration;
            cart.course_period = "Hour(s)";
            if (course.durationUnit === "Second(s)" && course.duration >= 60) {
              console.log("COURSE", course);
              if (course.duration % 60) {
                course.duration = convertTimeFormat(course.duration, true);
              } else {
                course.duration = convertSecondsToMins(course.duration);
                course.duration = convertTimeFormat(course.duration);
              }
              course.durationUnit = "";
            } else if (
              course.durationUnit === "Second(s)" &&
              course.duration < 60
            ) {
              course.duration = `${course.duration} Sec${
                course.duration > 1 ? "s" : ""
              }`;
              course.durationUnit = "";
            } else if (course.durationUnit === "Hours") {
              course.duration = convertHoursToMins(course.duration);
            }
            course.duration = convertTimeFormat(course.duration);
            course.durationUnit = "";
          }
        } else {
          if (cart.durationUnit === "Hours") {
            cart.duration = convertHoursToMins(cart.duration);
          }
          cart.duration = convertTimeFormat(cart.duration);
          cart.durationUnit = "";
        }
      }
      setMyCartDetails(cartData);
    }

    if (_.isEmpty(myCartRes)) {
      setCouponDetail({});
    } else {
      setCouponDetail(myCartRes?.coupon_data);
    }
  }, [myCartRes]);

  useEffect(() => {
    // console.log("myCartDetails: ", myCartDetails);
    if (myCartDetails !== undefined) {
      // console.log("product priice", parseInt(myCartDetails[0].product_sale_price))
      var total = 0;
      for (var i = 0; i < myCartDetails.length; i++) {
        total += parseFloat(myCartDetails[i].product_sale_price);
      }
      setSubTotalPrice(total);
      setTotalPrice(total);
      totalPriceFromApi();
    }
  }, [myCartDetails]);

  useEffect(() => {
    // console.log("creditPoint", creditPoints);
    if (!_.isEmpty(creditPoints)) {
      if (creditPoints.status === "success") {
        setUserCreditPoint(
          _.toNumber(creditPoints.payload.payload.credit_points)
        );
      }
    }
  }, [creditPoints]);

  const proceedToPayment = () => {
    clickStreamUser("proceed_to_buy_btn_click", {
      amount: totalPrice,
      item: myCartDetails.length,
      userId: auth.authBroker?.payload?.user.user_id,
    });
    dispatch(
      cartPageDataResponse({
        item: myCartDetails.length,
        price: fixedToDecimal(totalPrice, 2),
      })
    );
    navigate("/payment?redeempoints=" + redeemCard);
  };
  const [courseData, setCourseData] = useState({});
  const formatProductCardData = (course_data) => {
    let prodArr = [];
    let course = course_data;
    console.log("type-1", typeof prodArr);
    // for (let course of course_data) {
    let tags = [];
    let btnTitle = t("Explore");
    if (course?.provider?.provider_display_name) {
      tags.push(course.provider.provider_display_name);
    } else if (course?.provider?.display_name) {
      tags.push(course.provider.display_name);
    }

    if (course.product_type === "learningpath") {
      tags.push("Action Path");
    }
    if (
      course.product_type === "bundle" ||
      course.product_type === "learningpath"
    ) {
      if (course.learningpath_count > 0) {
        tags.push(
          `${course.learningpath_count} Action Path${
            course.learningpath_count > 1 ? "s" : ""
          }`
        );
      }
      if (course.course_count > 0)
        tags.push(
          `${course.course_count} Course${course.course_count > 1 ? "s" : ""}`
        );
      if (course.video_count > 0)
        tags.push(
          `${course.video_count} Video${course.video_count > 1 ? "s" : ""}`
        );
      if (course.event_count > 0)
        tags.push(
          `${course.event_count} Event${course.event_count > 1 ? "s" : ""}`
        );
    } else if (course.product_type === "video") {
      tags.push("Video");
      tags.push(`${course.views} ${t("View")}${course.views > 1 ? "s" : ""}`);
    } else if (course.product_type === "coaching") {
      tags.push("Coaching");
      course.product_type = "service";
      course.crscd = course?.service_code;
    } else if (course.product_type === "roleplay") {
      tags.push("Role play");
    } else {
      tags.push("Course");
      if (course.lessons) {
        tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
      }
    }

    if (course?.duration) {
      tags.push(convertTimeFormat(course.duration, true));
    }
    let priceInfo = "";
    if (course?.purchased_info) {
      priceInfo = getProcureInfo(course?.purchased_info);
      course.priceInfo = priceInfo;
    }

    console.log("type-2", typeof prodArr);
    prodArr.push({
      id:
        course?.product_type === "learningpath"
          ? course?.ecom_id
          : course?.product_id
          ? course?.product_id
          : course?.id,
      is_like: course?.is_like ? course?.is_like : false,
      is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
      dbId: course?.list_id,
      productType: course?.product_type,
      productOrigin:
        course?.product_type === "learningpath"
          ? course?.origin
          : course?.source,
      title: course?.name,
      fromWishList: true,
      logoURL: course?.provider?.provider_img
        ? course?.provider?.provider_img
        : "",
      bannerURL:
        // course?.product_type === "course"
        //   ? course?.imageURL
        //   : course?.product_type === "video"
        //   ? course?.product_thumbnail
        //   : course?.product_type === "learningpath" ||
        //     course?.product_type === "service"
        //   ? course?.thumbnail
        //   : "",
        course?.thumbnail ? course?.thumbnail : "",
      tagsArray: tags,
      description: course?.short_description,
      btnTitle: btnTitle,
      progress: course?.crs_progress,
      showLikeMenu: true,
      btnAction: () =>
        redirectToPageUtil(
          course,
          navigate,
          authBroker,
          setCourseData,
          dispatch
        ),
      descAction: {},
      bannerAction: () =>
        redirectToPageUtil(
          course,
          navigate,
          authBroker,
          setCourseData,
          dispatch
        ),
      footerLineComp: !_.isEmpty(priceInfo)
        ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
        : "",
      showHeader: true,
      showProviderIcon: true,
      showBody: course?.short_description ? true : false,
      showFooter: true,
      showProgress: _.toNumber(course?.crs_progress) > 0 ? true : false,
      cardClassName: "",
      rightBtnIcon: "/images/arrow-right.svg",
      lefttBtnIcon: "",
      isLoading: false,
      updatedAt: course?.product_type === "coaching" ? "" : course?.created_dt,
      priceInfo,
      isBundle: course?.product_type === "bundle",
      bundles: course?.bundles,
    });
    // }
    console.log("idsss--", prodArr);
    return prodArr;
  };

  const loaderResponse = useSelector((state) => state.home.showLoader);

  useEffect(() => {
    if (loaderResponse === "true") {
      props.setIsLoading(true);
    }
  }, [loaderResponse]);

  useEffect(() => {
    console.log("wishlistres: ", wishListRes);
    if (!_.isEmpty(wishListRes)) {
      props.setIsLoading(false);
      dispatch(getShowLoader("false"));
      let list = [];
      if (wishListRes.status === "success" && !_.isEmpty(wishListRes.payload)) {
        for (let course of wishListRes.payload) {
          list.push(formatProductCardData(course)[0]);
          console.log("list--", list);
        }
        setWishList(list);
      } else {
        setWishList([]);
      }
    }
  }, [wishListRes]);

  return (
    <>
      <section className="my_cart">
        <div className={`cart-wrapper`}>
          <div className="container">
            <div className="row">
              <h3>{t("My Wishlist")}</h3>
            </div>
            {wishlist.length > 0 ? (
              <>
                <div className="row">
                  <div className="col-xl-12 col-md-12 col-sm-12 cart-content">
                    <p className="mb-3">{wishlist.length} {t("Item(s)")}</p>
                    <div className="row coursecard-row videosection-cont">
                      {wishlist.map((video, i) => {
                        return (
                          <ProductCardComponent
                            {...video}
                            key={`video-${i + 1}`}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="not-found mt-3">
                <div className="interboxes">
                  <NotFoundImage />
                  <p>{t("No item added yet.")}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};
export default WishlistSection;
